import BaseComponent from "../BaseComponent";
import ToggleInput from "components/Properties/InputComponents/ToggleInput";
import TextureLibraryInput from "components/Properties/InputComponents/TextureLibraryInput";

const EnvironmentComponent = ({scene, inputOnChange, checkboxOnChange}) => {
  return (
    <BaseComponent title="Environment" foldable={true}>
      <ToggleInput name="Equirect" checked={scene.environment !== null} checkboxOnChange={checkboxOnChange} />
      <TextureLibraryInput name="Equirect" inputOnChange={inputOnChange} thumbnail={scene.userData.environment} />
    </BaseComponent>
  );
};

export default EnvironmentComponent;
